export const GET_OFFERING_VARIATIONS = "host/offering/variant/get";
export const CREATE_OFFERING_VARIATION = "host/offering/variant/create";
export const UPDATE_OFFERING_VARIATION = "host/offering/variant/update";
